import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { INPUT_TYPES_MAP, InputTypeMap } from '@constants/input-types-map';
import { enumBondType } from '@data-layer/enums/common';
import { DEFAULT_CURRENCY_CODE } from '@constants/currency';

@Component({
  selector: 'app-bond-edit-form',
  templateUrl: './bond-edit-form.component.html',
  styleUrls: ['./bond-edit-form.component.scss'],
})
export class BondEditFormComponent {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public errors: any;
  @Input() public showSuretyCodeForContinuousBond: boolean = false;
  @Input() public showRefNumberForContinuousBond: boolean = false;
  @Input() public isDesktop: boolean = false;

  @Output() public selectCustomContinuousBond: EventEmitter<any> = new EventEmitter<any>();

  public enumBondType: typeof enumBondType = enumBondType;

  public integerInputMap: InputTypeMap = INPUT_TYPES_MAP.INTEGER;
  public currencyInputMap: InputTypeMap = INPUT_TYPES_MAP.CURRENCY;
  public DEFAULT_CURRENCY_CODE: string = DEFAULT_CURRENCY_CODE;
}
